// import Vue from 'vue'
// import moment from 'moment'

// /**
//  * 将utc模式下的默认配置，更改为后端需要的类型，同时也与element 时间组件的格式保持一致
//  * @type {string}
//  */
// moment.defaultFormat = 'YYYY-MM-DDTHH:mm:ss.SSSZZ'
// moment.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss.SSSZZ'
// moment.prototype.formatDate = data => moment(data).format('YYYY-MM-DD')
// moment.prototype.formatTime = data => moment(data).format('YYYY-MM-DD HH:mm:ss')

// window.$moment = moment
// Vue.prototype.$moment = moment

export const clientTimeZone = () => {
  const munites = new Date().getTimezoneOffset()
  // eslint-disable-next-line radix
  let hour = parseInt(munites / 60)
  const munite = munites % 60
  let prefix = 'GMT-'
  if (hour < 0 || munite < 0) {
    prefix = 'GMT+'
    hour = -hour
  }
  hour += ''
  return prefix + hour
}
